import { render, staticRenderFns } from "./Shopper.vue?vue&type=template&id=252d60d3&"
import script from "./Shopper.vue?vue&type=script&lang=js&"
export * from "./Shopper.vue?vue&type=script&lang=js&"
import style0 from "./Shopper.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports